import { addDays, startOfISOWeek, format } from 'date-fns';
import { useDayPicker } from 'react-day-picker';

const DayPickerHeader = (): JSX.Element => {
  const {
    locale,
    labels: { labelWeekday },
  } = useDayPicker();

  const start = startOfISOWeek(new Date());

  const weekdays = [];
  for (let i = 0; i < 7; i++) {
    const day = addDays(start, i);
    weekdays.push(day);
  }

  return (
    <tr>
      {weekdays.map((weekday, i) => (
        <th
          key={i}
          scope="col"
          className="h-10 w-10 cursor-default p-0 text-sm font-medium capitalize"
          aria-label={labelWeekday(weekday, { locale })}
        >
          {format(weekday, 'eeeeee', { locale })}
        </th>
      ))}
    </tr>
  );
};

export default DayPickerHeader;
